export default "/images/vendor/flag-icon-css/flags/1x1/mk.svg?d335b1f7842c183f2626026980bb59d7";